import { useParams } from 'react-router-dom'

import { useLlmoAnalysisDetailApi } from '@/common/api/modules/llmo'
import { QueryFanoutHistoryDetailResponse } from '@/common/api/params/llmo'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import QueryFanoutResultView from '@/components/container/modules/mediaGeo/queryFanout/QueryFanoutResultView'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// クエリファンアウト分析結果（GEO/LLMO）
const MediaAnalysisQueryFanoutResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useLlmoAnalysisDetailApi<QueryFanoutHistoryDetailResponse>(
    siteId && historyId ? { site_id: sid, history_id: Number(historyId) } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.QUERY_FANOUT}
      data={data}
      error={error}
      resultError={data?.result?.error}
    >
      {data?.result && (
        <QueryFanoutResultView result={data.result} siteId={sid} historyId={Number(historyId)} />
      )}
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisQueryFanoutResultPage
